/**
 * @generated SignedSource<<463cad0f6168c2b645a90b54560b02ee>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_sortedPhotos$data = ReadonlyArray<{
  readonly __typename: "ItemPhoto";
  readonly imageSkuXrefs: ReadonlyArray<{
    readonly skuId: string | null;
  } | null> | null;
  readonly largePath: string | null;
  readonly masterOrZoomPath: string | null;
  readonly " $fragmentType": "useItemMediaItems_sortedPhotos";
}>;
export type useItemMediaItems_sortedPhotos$key = ReadonlyArray<{
  readonly " $data"?: useItemMediaItems_sortedPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_sortedPhotos">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useItemMediaItems_sortedPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largePath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSkuXref",
      "kind": "LinkedField",
      "name": "imageSkuXrefs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skuId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "7cdb5c8c8ebe14a48577610b1d7884d8";

export default node;
